export default "__VITE_ASSET__BCL50nK1__"